export default __webpack_public_path__ + "static/media/keto_hydration@2x.6d462e86.jpg";